var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item",attrs:{"to":{ name: _vm.to },"title":_vm.label,"exact":_vm.exact}},[_c('span',{staticClass:"nav-icon"},[_c('i',{class:_vm.iconName})]),_vm._v(" "),_c('span',{staticClass:"nav-label",domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),(_vm.alerts)?_c('span',{staticClass:"nav-alert tag is-primary",domProps:{"textContent":_vm._s(_vm.alerts)}}):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff5525c4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav/Link.vue
// module id = null
// module chunks = 